import { render } from "./footerInternas.vue?vue&type=template&id=64dd8641"
const script = {}

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__